const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/finance/deposits.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */

import { getFindAllDepositsQueryOptions } from '@api';
import { createTableQuerySchema } from '@common';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
import { z } from 'zod';
const searchSchema = createTableQuerySchema({}).extend({
  dueDateFrom: z.string().optional(),
  dueDateTo: z.string().optional()
});
export const Route = createFileRoute('/_rootLayout/finance/deposits')({
  validateSearch: search => searchSchema.parse(search),
  loader: async ({
    context: {
      queryClient
    },
    location
  }) => {
    queryClient.ensureQueryData(getFindAllDepositsQueryOptions(location.search));
    return {
      crumb: t('NAVIGATION.FINANCE'),
      to: '/finance/deposits'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});